import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getClinicInfo, updateClinicProfileInfo } from "../../../../store/slices/clinicSlice";
import {
  showToastifySuccess,
  showToastifyError,
} from "../../../common/tostify/Toastifyresponse";
import { resetUpdateMessages } from "../../../../store/slices/clinicSlice";
import { getStateSlice } from "../../../../store/slices/state";
import { getCitySlice } from "../../../../store/slices/citySlice";
import { getCountrySlice } from "../../../../store/slices/countrySlice";
import ProfileAddEdit from "./ProfileAddEdit";
import ProfileView from "./ProfileView";

const MyProfile = () => {
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [deleteModal, setDeleteModal] = useState(false);
  const { clinicInfo, updateSuccessMessage, updateErrorMessage } = useSelector((state) => state.clinic);
  const { token, userInfo } = useSelector((state) => state.auth);
  const { cities } = useSelector((state) => state.city);
  const { Country } = useSelector((state) => state.country);
  const { state } = useSelector((state) => state.state);
  const clinic = clinicInfo && clinicInfo.length > 0 ? clinicInfo[0] : [];
  const [uploadedImage, setUploadedImage] = useState(null);
  const [clinicProfileData, setClinicProfileData] = useState({
    clinicName: "",
    phone: "",
    clinicEmail: "",
    alternateClinicPhone: "",
    tagline: "",
    youtube: "",
    facebook: "",
    instagram: "",
    twitter: "",
    clinic_image: null,
    clinicAddress: {
      area: "",
      city: "",
      cityName: "",
      country: "",
      countryName: "",
      state: "",
      stateName: "",
      street: "",
      plot: "",
      landMark: "",
      pin: "",
    },
  });
  const [inputError, setInputError] = useState({
    name: false,
    email: false,
    phNumber: false,
    pinCode: false,
  });

  useEffect(() => {
    dispatch(getCountrySlice({ token }));
  }, [dispatch, token]);

  useEffect(() => {
    if (updateSuccessMessage) {
      showToastifySuccess(updateSuccessMessage);
      dispatch(resetUpdateMessages());
    }
    if (updateErrorMessage) {
      showToastifyError(updateErrorMessage);
      dispatch(resetUpdateMessages());
    }
  }, [dispatch, updateSuccessMessage, updateErrorMessage]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (
      name === "clinicName" ||
      name === "phone" ||
      name === "clinicEmail" ||
      name === "tagline" ||
      name === "youtube" ||
      name === "facebook" ||
      name === "instagram" ||
      name === "twitter" ||
      name === "alternateClinicPhone"
    ) {
      setClinicProfileData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      setClinicProfileData((prevData) => ({
        ...prevData,
        clinicAddress: {
          ...prevData.clinicAddress,
          [name]: value,
        },
      }));
    }
  };

  const handleSelectChange = async (selectedOption, name) => {
    if (name === "city") {
      setClinicProfileData((prevData) => ({
        ...prevData,
        clinicAddress: {
          ...prevData.clinicAddress,
          city: selectedOption.value,
          cityName: selectedOption.label,
        },
      }));
    } else if (name === "country") {
      setClinicProfileData((prevData) => ({
        ...prevData,
        clinicAddress: {
          ...prevData.clinicAddress,
          country: selectedOption.value,
          countryName: selectedOption.label,
        },
      }));
      await dispatch(getStateSlice({ countryId: selectedOption.value, token }));
    } else if (name === "state") {
      setClinicProfileData((prevData) => ({
        ...prevData,
        clinicAddress: {
          ...prevData.clinicAddress,
          state: selectedOption.value,
          stateName: selectedOption.label,
        },
      }));
      await dispatch(
        getCitySlice({
          countryId: clinicProfileData.clinicAddress.country,
          stateId: selectedOption.value,
          token
        })
      );
    }
  };
  useEffect(() => {
    dispatch(resetUpdateMessages({ token }));
  }, [dispatch, token]);

  const handleEdit = (item) => {
    setDeleteModal(true);
    setClinicProfileData({
      clinicName: item?.clinicName,
      phone: item?.phone,
      clinicEmail: item?.clinicEmail,
      tagline: item?.tagline,
      youtube: item?.youtube,
      facebook: item?.facebook,
      instagram: item?.instagram,
      twitter: item?.twitter,
      alternateClinicPhone: item?.alternateClinicPhone,
      clinicAddress: {
        area: item?.clinicAddress?.area,
        city: item?.clinicAddress?.city?._id,
        cityName: item?.clinicAddress?.city?.name,
        country: item?.clinicAddress?.country?._id,
        countryName: item?.clinicAddress?.country?.name,
        state: item?.clinicAddress?.state?._id,
        stateName: item?.clinicAddress?.state?.name,
        street: item?.clinicAddress?.street,
        plot: item?.clinicAddress?.plot,
        landMark: item?.clinicAddress?.landMark,
        pin: item?.clinicAddress?.pin,
      },
    });
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    const { name, email, phNumber, pinCode } = inputError;
    if (name || email || phNumber || pinCode) {
      return;
    }
    try {
      const formData = new FormData();
      if (clinic?.userId?._id) formData.append("userId", clinic?.userId?._id);
      if (clinicProfileData?.clinicName) formData.append("clinicName", clinicProfileData?.clinicName);
      if (clinicProfileData?.phone) formData.append("phone", clinicProfileData?.phone);
      if (clinicProfileData?.alternateClinicPhone) formData.append("alternateClinicPhone", clinicProfileData?.alternateClinicPhone);
      if (clinicProfileData?.clinicEmail) formData.append("clinicEmail", clinicProfileData?.clinicEmail);
      if (uploadedImage) {
        formData.append("clinic_image", uploadedImage);
      } else if (clinic?.clinic_image) {
        formData.append("existing_clinic_image", clinic?.clinic_image);
      }
      formData.append("tagline", clinicProfileData?.tagline);
      formData.append("area", clinicProfileData?.clinicAddress?.area);
      formData.append("street", clinicProfileData?.clinicAddress?.street);
      formData.append("plot", clinicProfileData?.clinicAddress?.plot);
      formData.append("landMark", clinicProfileData?.clinicAddress?.landMark);
      formData.append("pin", clinicProfileData?.clinicAddress?.pin);
      if (clinicProfileData?.clinicAddress?.country) formData.append("country", clinicProfileData?.clinicAddress?.country);
      if (clinicProfileData?.clinicAddress?.state) formData.append("state", clinicProfileData?.clinicAddress?.state);
      if (clinicProfileData?.clinicAddress?.city) formData.append("city", clinicProfileData?.clinicAddress?.city);
      formData.append("youtube", clinicProfileData?.youtube);
      formData.append("facebook", clinicProfileData?.facebook);
      formData.append("instagram", clinicProfileData?.instagram);
      formData.append("twitter", clinicProfileData?.twitter);
      await dispatch(updateClinicProfileInfo({ formData, token })).unwrap();
      await dispatch(getClinicInfo({ userId: userInfo?._id, token }));
      setDeleteModal(false);
    } catch (error) {
      console.error(error);
    }
  };


  const handleCameraClick = () => {
    fileInputRef.current.click();
  };
  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedImage(file);
      try {
        const formData = new FormData();
        formData.append("userId", clinic?.userId?._id);
        formData.append("clinic_image", file);
        if (clinic?.clinicAddress?.area) formData.append("area", clinic?.clinicAddress?.area);
        if (clinic?.clinicAddress?.city?._id) formData.append("city", clinic?.clinicAddress?.city?._id);
        if (clinic?.clinicAddress?.country?._id) formData.append("country", clinic?.clinicAddress?.country?._id);
        if (clinic?.clinicAddress?.state?._id) formData.append("state", clinic?.clinicAddress?.state?._id);
        if (clinic?.clinicAddress?.street) formData.append("street", clinic?.clinicAddress?.street);
        if (clinic?.clinicAddress?.plot) formData.append("plot", clinic?.clinicAddress?.plot);
        if (clinic?.clinicAddress?.landMark) formData.append("landMark", clinic?.clinicAddress?.landMark);
        if (clinic?.clinicAddress?.pin) formData.append("pin", clinic?.clinicAddress?.pin);
        await dispatch(updateClinicProfileInfo({ formData, token })).unwrap();
        await dispatch(getClinicInfo({ userId: userInfo?._id, token }));
        setDeleteModal(false);
      } catch (error) {
        console.log(error);
      }
    }
  };


  return (
    <>
      <ProfileView
        clinicProfileData={clinicProfileData}
        clinic={clinic}
        handleEdit={handleEdit}
        handleImageUpload={handleImageUpload}
        handleCameraClick={handleCameraClick}
        fileInputRef={fileInputRef}
      />
      <ProfileAddEdit
        handleInputChange={handleInputChange}
        clinicProfileData={clinicProfileData}
        handleSelectChange={handleSelectChange}
        Country={Country}
        cities={cities}
        state={state}
        handleEdit={handleEdit}
        deleteModal={deleteModal}
        setDeleteModal={setDeleteModal}
        handleUpdate={handleUpdate}
        setInputError={setInputError}
      />
    </>
  );
};

export default MyProfile;
